import { QuestionTitle, PageControls } from '../../components';
import { useTranslation } from 'react-i18next';
import { QuestionWrapper } from 'common/components';
import { BestOfTempletonAccountCreationForm } from 'common/forms';
import { FormikProps } from 'formik';
import { BestOfTempletonAccountFormValues } from 'common/models/Forms';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectStrategy,
  setBestOfTempletonAccountInfo,
  selectBestOfTempletonAccountInfo,
  selectInvestingExperience,
  selectInvestingHazard,
} from 'features/form/ducks';
import { useFormStepContinueRef } from '../../hooks/useFormStepContinueRef';

export default function BestOfTempletonAccountFeature() {
  const { t } = useTranslation();
  const { id } = useParams();
  const strategy = useSelector(selectStrategy);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = useSelector(selectBestOfTempletonAccountInfo);
  const investingExperienceValues = useSelector(selectInvestingExperience);
  const hazard = useSelector(selectInvestingHazard);

  const { bindFormik, continueWithSoftValidation, showSoftContinueHint } =
    useFormStepContinueRef<BestOfTempletonAccountFormValues>();

  function bindSubmit(formik: FormikProps<BestOfTempletonAccountFormValues>) {
    bindFormik(formik);
  }

  function handleSubmit(values: BestOfTempletonAccountFormValues) {
    dispatch(setBestOfTempletonAccountInfo(values));
    navigate(`/form/${id}/transaction`);
  }

  async function handleContinueClick() {
    await continueWithSoftValidation((values) => {
      handleSubmit(values);
    });
  }

  function handleBackClick() {
    navigate(-1);
  }

  return (
    <>
      <QuestionTitle>{t('bestOfTempletonFeature.title')}</QuestionTitle>
      <QuestionWrapper>
        <BestOfTempletonAccountCreationForm
          initialValues={initialValues || undefined}
          investingExperienceValues={investingExperienceValues || undefined}
          onSubmit={handleSubmit}
          bindSubmit={bindSubmit}
          strategy={strategy}
          hazard={hazard || undefined}
        />
      </QuestionWrapper>
      <PageControls softContinueHint={showSoftContinueHint} onBack={handleBackClick} onContinue={handleContinueClick} />
    </>
  );
}
